import React, { Component } from 'react';

const importAll = (r) => {
    return r.keys().map(r);
};

const images = importAll(
    require.context('../heatmaps', false, /\.(png)$/)
);

class HeatmapDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedPicture: images.length > 0 ? images[0] : null, // Set the first picture as default
        };
    }

    handlePictureChange = (event) => {
        const selectedPicture = event.target.value;

        this.setState({
            selectedPicture,
        });
    };

    extractClassName = (imagePath) => {
        // Split the image path by '/' and select the last part
        const parts = imagePath.split('/');
        const className = parts[parts.length - 1];

        // Remove the file extension (e.g., .png)
        const classNameWithoutExtension = className.split('.')[0];

        return classNameWithoutExtension;
    };

    render() {
        const containerStyle = {
            position: 'fixed',
            top: '50%', // Vertically centered
            right: '20px', // Move 20 pixels from the right
            transform: 'translateY(-50%)', // Center vertically
            backgroundColor: 'white',
            padding: '40px', // Increase padding for a larger appearance
            zIndex: '999',
            fontFamily: 'Arial',
            textAlign: 'center',
            borderRadius: '10px', // Add border radius for a more beautiful look
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)', // Add a shadow for depth
        };

        const titleStyle = {
            fontSize: '24px',
            color: '#333',
            marginBottom: '20px',
        };

        const selectStyle = {
            fontSize: '16px',
            padding: '15px', // Increase padding for a larger dropdown
            width: '250px', // Adjust the width as needed
            borderRadius: '10px',
            border: '2px solid #1E90FF',
            background: 'transparent', // Set background to transparent
            textAlign: 'center',
        };

        const imageStyle = {
            marginTop: '20px',
            maxWidth: '400px', // Increase the image size
            borderRadius: '10px', // Add border radius to the image
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)', // Add a shadow for depth
        };

        return (
            <div style={containerStyle}>
                <h1 style={titleStyle}>Class Emotional Heatmap</h1>
                <select
                    id="pictureDropdown"
                    value={this.state.selectedPicture || ''}
                    onChange={this.handlePictureChange}
                    style={selectStyle}
                >
                    {images.map((image, index) => (
                        <option key={index} value={image}>
                            {this.extractClassName(image)}
                        </option>
                    ))}
                </select>

                {this.state.selectedPicture && (
                    <div style={imageStyle}>
                        <img
                            src={this.state.selectedPicture}
                            alt="Selected Picture"
                            style={{ maxWidth: '100%', height: 'auto' }} // Maintain aspect ratio
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default HeatmapDropdown;
